import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=11705ec6&"
import script from "./register-form.vue?vue&type=script&lang=js&"
export * from "./register-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports